import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";
import FormColor from "./FormColor";
import Modal from "../../sharecomponents/Modal";

const CatalogoColores = (props) => {
   const [colores, setColores] = useState([]);
   const [color, setColor] = useState(null);
   // modal
   const modalRef = useRef();

   useEffect(() => {
      getColores();
   }, []);

   const getColores = () => {
      axios
         .get(API_URL + "/catalogos/getColores")
         .then((r) => {
            setColores(r.data.colores);
         })
         .catch((e) => console.log(e));
   };

   const actionModal = () => {
      axios.post(API_URL + "/delColor", { id: color.id }).then((r) => {
         getColores();
      });
      modalRef.current.hideModal();
   };

   const delColor = (c) => {
      setColor(c);
      modalRef.current.showModal();
   };

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <h5 className="font-bold uppercase text-white">Catálogo de Colores</h5>
            </div>
            <div className="p-5 rounded-b">
               {/* ---- CONTENIDO --- */}
               <div className="flex mb-4">
                  <div className="w-1/2 p-1">
                     <h2>Alta del Color</h2>
                     <hr className="mb-5" />
                     <FormColor fn={getColores} />
                  </div>
                  <div className="w-1/2 p-1">
                     <h2>Listado de Colores</h2>
                     <hr className="mb-5" />
                     <table className="mb-3">
                        <thead>
                           <tr className="text-sm text-white content-center bg-orange-800">
                              <th className="bg-white border-white border-l-0 border-t-0"></th>
                              <th className="w-auto px-1 py-1">Color</th>
                              <th className="w-auto px-1 py-1">Descripción</th>
                           </tr>
                        </thead>
                        <tbody>
                           {colores.length > 0 &&
                              colores.map((c, i) => {
                                 return (
                                    <tr key={i} className="text-sm">
                                       <td className="border px-4 py-2">
                                          <button className="px-1 py-1 focus:outline-none" onClick={() => delColor(c)}>
                                             <i className="far fa-trash-alt" />
                                          </button>
                                       </td>
                                       <td className="border px-4 py-2">{c.color}</td>
                                       <td className="border px-4 py-2">{c.descripcion}</td>
                                    </tr>
                                 );
                              })}
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
         <Modal
            titulo="Remover Color"
            mensaje={`¿Seguro de remover el Color seleccionado?`}
            ref={modalRef}
            actionTitle="Remover"
            actionFn={actionModal}
         />
      </div>
   );
};

export default CatalogoColores;
